import React from 'react';
import logoText from '@assets/logo.png';
import { Card } from '@components/atoms/Card';
import { Button } from '@components/atoms/Button';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '@redux/hooks';
import { logoutUser } from '@redux/reducers/user.reducer';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from '@hooks/useTranslation';

const HomePage: React.FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  // Sprint 28, story-142. Web-only `home.*` section — docs/architecture.md "## Sprint 28" Decision 1.
  const tHome = useTranslation('home');

  // This screen has no navigation chrome, so without this the only way out is
  // clearing the browser session by hand.
  const handleLogout = () => {
    dispatch(logoutUser());
    history.push('/login');
  };

  return (
    <div className="flex flex-col gap-10 items-center justify-center min-h-screen bg-indigo-950 dark:bg-neutral-900 p-4">
      <img
        src={logoText}
        alt="App usage info"
        className="max-w-sm w-full mb-4 md:mb-0 md:mr-6"
      />

      <Card className="max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6">
        <div>
          <h1 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            {tHome.welcomeTitle}
          </h1>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            {tHome.useMobileApp}
          </p>

          {/* Primary rather than the quieter variants used on the other
              dead-end screens: there they sit next to a stronger action, here
              leaving is the only thing the user can do. */}
          <Button
            variant="primary"
            fullWidth
            className="mt-6"
            onClick={handleLogout}
            leftIcon={<LogoutIcon fontSize="small" />}>
            {tHome.logout}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default HomePage;
